// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e018a3b8","977":"1d2ae64c"}[chunkId] + ".chunk.js";
};